import React from 'react'
import { WidgetId } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { InsightViewOption } from 'enums'

import useDayAndHourData from '../useDayAndHourData'
import { DayAndHourWidgetsType, InsightsSelectFunc } from '../../types'
import BarDisplay from './BarDisplay'
import HeatmapDisplay from './HeatmapDisplay'

interface DayAndHourChartProps {
  widgetId: WidgetId
  onInsightsSelect?: InsightsSelectFunc
  heatmapKey?: string
}

const DayAndHourChart = ({ widgetId, onInsightsSelect, heatmapKey }: DayAndHourChartProps) => {
  const dayAndHourData = useDayAndHourData(widgetId)
  const widgetSetting = useDashboardWidgetSetting<DayAndHourWidgetsType>(widgetId)
  const { viewOption } = widgetSetting

  switch (viewOption) {
    case InsightViewOption.HOUR_OF_DAY:
      return (
        <BarDisplay
          dayAndHourData={dayAndHourData}
          widgetSetting={widgetSetting}
          onInsightsSelect={onInsightsSelect}
        />
      )
    case InsightViewOption.DAY_OF_WEEK:
      return (
        <BarDisplay
          dayAndHourData={dayAndHourData}
          widgetSetting={widgetSetting}
          onInsightsSelect={onInsightsSelect}
        />
      )
    case InsightViewOption.HOUR_OF_WEEK:
      return (
        <HeatmapDisplay
          key={heatmapKey}
          dayAndHourData={dayAndHourData}
          widgetSetting={widgetSetting}
          onInsightsSelect={onInsightsSelect}
        />
      )
    default:
      throw new Error(`Unsupported viewOption: ${viewOption}`)
  }
}

export default DayAndHourChart
